import { render } from "./Sex.vue?vue&type=template&id=5717b1c0"
import script from "./Sex.vue?vue&type=script&lang=js"
export * from "./Sex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__